<div class="card lc-acces-page" style="margin: 0 15px 15px; min-height: 100vh; padding-top: 24px">
  <div *ngIf="loading" class="text-center py-5 text-muted">
    <span class="spinner-border spinner-border-sm me-2"></span>
    Chargement des accès…
  </div>

  <div *ngIf="!loading && needsConfiguration()" class="lc-empty-state mx-auto">
    <div class="lc-empty-icon">
      <i data-feather="monitor"></i>
    </div>
    <h4 class="mb-2">Configuration logiciel caisse requise</h4>
    <p class="text-muted mb-2" *ngIf="syncStatus?.action === 'setup'">
      Aucun accès trouvé pour la station <strong>{{ code_station }}</strong>
      (ERP et back logiciel caisse).
    </p>
    <p class="text-muted mb-2" *ngIf="syncStatus?.action === 'resync'">
      Accès ERP présent mais utilisateur absent ou incomplet sur le back logiciel caisse.
      Recréez la configuration pour synchroniser les deux systèmes.
    </p>
    <p class="text-muted mb-4">
      Activez le module puis créez l’accès — l’utilisateur sera enregistré dans
      <strong>acces_logiciel_caisse</strong> (ERP) et dans <strong>users</strong> (back caisse).
    </p>
    <button type="button" class="btn btn-primary" (click)="startConfiguration()">
      Commencer la configuration
    </button>
  </div>

  <div *ngIf="!loading && !needsConfiguration() && accesRows.length > 0" class="px-3 pb-4">
    <div class="alert alert-success d-flex align-items-center justify-content-between flex-wrap gap-2" *ngIf="lcConnected">
      <span>Connexion au logiciel caisse active pour cette station.</span>
      <button type="button" class="btn btn-sm btn-primary" (click)="openTickets()">Ouvrir les tickets</button>
    </div>

    <div class="alert alert-warning d-flex align-items-center justify-content-between flex-wrap gap-2" *ngIf="!lcConnected">
      <span>Configuration incomplète : finalisez l’accès logiciel caisse pour cette station.</span>
      <button type="button" class="btn btn-sm btn-primary" (click)="goToConfigure()">Continuer la configuration</button>
    </div>

    <div class="table-responsive mt-3">
      <table class="table table-hover">
        <thead>
          <tr>
            <th>Email</th>
            <th>Code station</th>
            <th>Statut</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of accesRows">
            <td>{{ row.email }}</td>
            <td>{{ row.code_station }}</td>
            <td>
              <span class="badge bg-light-success">Actif</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>
